import Button from "components/Button/Button";
import Card from "components/Card/Card";
import Section111ClaimantMatchPicker from "components/Section111ClaimantMatchPicker/Section111ClaimantMatchPicker";
import type { Section111ClaimantMatch } from "services/claims-api";

import KaboodleModal from "./KaboodleModal";

type Section111ClaimantMatchesModalProps = {
  isOpen: boolean;
  matches: Section111ClaimantMatch[];
  isFetching: boolean;
  isError: boolean;
  onSelect: (match: Section111ClaimantMatch) => void;
  onDismiss: () => void;
};

const Section111ClaimantMatchesModal = ({
  isOpen,
  matches,
  isFetching,
  isError,
  onSelect,
  onDismiss,
}: Section111ClaimantMatchesModalProps) => (
  <KaboodleModal
    isOpen={isOpen}
    onClose={onDismiss}
    footer={
      <div className="flex jc-c">
        <Button onClick={onDismiss}>Continue Without Section 111 Data</Button>
      </div>
    }
  >
    <Card heading="Section 111 Record Found" type="full-width">
      <p>
        We found a Section 111 record that matches what you&apos;ve entered so
        far. Select it to fill in the first name, last name, date of birth, and
        SSN below, or continue entering the claimant&apos;s information
        yourself.
      </p>
      <Section111ClaimantMatchPicker
        matches={matches}
        isFetching={isFetching}
        isError={isError}
        onSelect={onSelect}
        emptyMessage="No matching Section 111 records found for this SSN, or name and date of birth."
      />
    </Card>
  </KaboodleModal>
);

export default Section111ClaimantMatchesModal;
